import { sendAnalytics } from '@audio-network/analytics'
import { Container, Heading, Paragraph } from '@audio-network/componentlibrary'
import { Trans, useTranslation } from 'next-i18next'
import React from 'react'

const Header = (
	props: React.DetailedHTMLProps<
		React.HTMLAttributes<HTMLDivElement>,
		HTMLDivElement
	>
): JSX.Element => {
	const { t } = useTranslation(['albums'])

	const handleSearchOnClick = (): void => {
		sendAnalytics({
			noun: 'Albums Search Link',
			pastTenseVerb: 'Clicked',
		})
	}

	return (
		<header {...props}>
			<Container maxWidth="large">
				<Heading level={1} size="L" uppercase>
					{t('title')}
				</Heading>

				<Paragraph data-testid="search-prompt">
					<Trans
						i18nKey={t('search-prompt')}
						components={{
							1: (
								// eslint-disable-next-line jsx-a11y/anchor-has-content
								<a
									href="/search"
									target="_parent"
									onClick={handleSearchOnClick}
								/>
							),
						}}
					/>
				</Paragraph>
			</Container>
		</header>
	)
}

export default Header
